import webchat from './webchat';

export default function* () {
    yield* [...webchat];
}
